import {
  advancedSearchCriteriasSelector,
  buildAdvancedFilterList,
  BusinessFilter,
  currentDataLocaleSelector,
  getBusinessFiltersForCurrentLocale,
  KpkFilterType,
  sheetFieldsSelector,
} from "@keepeek/commons";
import { KSplitValue } from "@keepeek/refront-components";
import { selectorFamily } from "recoil";

import { kSplitValueAtom } from "./atom";
import { fieldIdText } from "./hooks";

export const kSplitValueSelector = selectorFamily<KSplitValue | undefined, string>({
  key: "KSplitValueSelector",
  get:
    (widgetId) =>
    ({ get }) => {
      const dataLocale = get(currentDataLocaleSelector);
      const currentFieldId = get(kSplitValueAtom(widgetId))?.id;
      if (currentFieldId && currentFieldId !== fieldIdText && dataLocale) {
        const sheetFields = get(sheetFieldsSelector);
        const criterias = get(advancedSearchCriteriasSelector) || [];
        // TODO: This is not generic, this function come from filters
        const filterList = buildAdvancedFilterList(currentFieldId, sheetFields, criterias);
        if (filterList) {
          // TODO: This is not generic, this function come from filters
          const filterListForCurrentLocale = getBusinessFiltersForCurrentLocale(
            filterList,
            dataLocale,
          );
          if (
            filterListForCurrentLocale &&
            filterListForCurrentLocale.length > 0 &&
            Object.keys(filterListForCurrentLocale[0]).some((k) => k === "filter")
          ) {
            const bf: BusinessFilter = filterListForCurrentLocale[0] as BusinessFilter;
            return {
              id: currentFieldId,
              label: bf.filter.label,
              type: bf.filter.type,
            };
          }
        }
      }

      return {
        id: fieldIdText,
        label: "search.input.split.item.text.label",
        type: KpkFilterType.Text,
      };
    },
  set:
    (widgetId) =>
    ({ set }, newValue) =>
      set(kSplitValueAtom(widgetId), newValue),
});
